var _path, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 91,
    viewBox: "0 0 101 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8017 7.9866L4.33538 72.9629C3.45528 74.4945 2.99462 76.2318 3.00005 77.999C3.00547 79.7663 3.47678 81.5007 4.36626 83.0268C5.25575 84.553 6.53185 85.8166 8.0654 86.6898C9.59896 87.563 11.3356 88.0149 13.0994 87.9996H87.9006C89.6644 88.0149 91.4011 87.563 92.9346 86.6898C94.4682 85.8166 95.7443 84.553 96.6337 83.0268C97.5232 81.5007 97.9945 79.7663 98 77.999C98.0054 76.2318 97.5447 74.4945 96.6646 72.9629L59.1107 7.9866C58.2296 6.46952 56.9667 5.21059 55.448 4.33555C53.9293 3.46051 52.2081 3 50.4562 3C48.7043 3 46.983 3.46051 45.4644 4.33555C43.9457 5.21059 42.6828 6.46952 41.8017 7.9866V7.9866Z",
    stroke: "#02378E",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.9995,
    y: 26,
    width: 9,
    height: 31,
    rx: 4.5,
    fill: "#FF7E64"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45.9995,
    y: 63,
    width: 9,
    height: 9,
    rx: 4.5,
    fill: "#FF7E64"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.daa0e1298e7f56f8bbfe2f7aabf7f331.svg";
export { ForwardRef as ReactComponent };